
export type IApiDocumentSchema = {
    documentCode: string,
    name: string,
    settings: IDocumentSchemaSettings,
}

export enum DocumentFieldType {
    DocumentKey = 'documentKey',
    String = 'string',
    Text = 'text',
    Number = 'number',
    Priority = 'priority',
    UtcDate = 'utcDate',
    User = 'user',
    Status = 'status',
    Identifier = 'identifier',
    Entity = 'entity',
}

export enum DocumentPlugin {
    Attachments = 'attachments',
    AttachmentWithTemplate = 'attachmentWithTemplate',
    Comments = 'comments',
    TimeTracking = 'timeTracking',
    QCResult = 'qcResult',
}

export type IDocumentFieldProps = {
    name: string,
    type: DocumentFieldType,
    typeProps: IDocumentIdentifierFieldProps | IDocumentStringFieldProps | IDocumentUtcDateFieldProps | IDocumentEntityFieldProps,
    columnProps: any,
    sourceObject: string,
    isRequired?: boolean,
    editProps?: {
        allowEditOnDetailsPage: boolean,
    },
}

export type IStatusIcon = {
    code: string,
    name: string,
    styleCode: string, // TODO
}

export type IDocumentStatus = {
    code: string,
    name: string,
    icon?: IStatusIcon,
    styleCode: string, // TODO: Use StatusStyleCode
}

export enum DynamicGridColumnComponent {
    TwoLineCell = 'TwoLineCell',
}

export type DynamicGridColumnProps = {
    sourceProperty: string,
    headerName: string,
    componentName?: string,
}

export enum DynamicFormFieldType {
    Hr = 'hr',
    Row = 'row',
}

export type DynamicFormFieldProps = {
    type: DynamicFormFieldType,
}

export type DynamicGridColumn = DynamicGridColumnProps | string;
export type DynamicFormField = DynamicFormFieldProps | string;

export type DocumentFormSettings = {
    createFields: DynamicFormField[],
    editFields: DynamicFormField[],
    cloneFields: DynamicFormField[],
}

export type IDocumentSchemaSettings = DocumentFormSettings & {
    dataProperties: {
        [key: string]: IDocumentFieldProps,
    },
    statusList: IDocumentStatus[],
    gridColumns: DynamicGridColumn[],
    plugins: DocumentPlugin[],
}

export type IDocumentStringFieldProps = {
    defaultValue: string,
}

export type IDocumentUtcDateFieldProps = {
    displayFormat: string,
}

export type IDocumentIdentifierFieldProps = {
    sourceListPropertyKey: string,
}


export enum DocumentEntityType {
    Department = 'department',
}

export type IDocumentEntityFieldProps = {
    entityType: DocumentEntityType,
}